import * as Y from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as m } from "../../utilities/transformations.js";
import { grain as j } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as B } from "../../utilities/uv.js";
const W = {
  name: "Horizon8",
  collection: "horizon",
  tags: ["gradient", "color", "fade", "mask"],
  props: {
    color1: {
      type: String,
      default: "#42a3d8",
      transform: m,
      description: "The first color of the horizon gradient."
    },
    color2: {
      type: String,
      default: "#5500ff",
      transform: m,
      description: "The second color of the horizon gradient."
    },
    color3: {
      type: String,
      default: "#ff05d5",
      transform: m,
      description: "The third color of the horizon gradient."
    },
    color4: {
      type: String,
      default: "#6b1ebf",
      transform: m,
      description: "The fourth color of the horizon gradient."
    },
    backgroundColor: {
      type: String,
      default: "#0b1229",
      transform: m,
      description: "The background color."
    }
  },
  fragmentNode: (d) => {
    const {
      vec2: n,
      vec3: T,
      vec4: _,
      mix: c,
      sin: u,
      cos: y,
      time: f,
      fract: x,
      dot: i,
      floor: F,
      smoothstep: k,
      PI: v,
      uv: S,
      float: b,
      length: U
    } = Y, E = 0, V = 0.22, A = 2, R = 0.06, g = (t = n(0)) => {
      const o = x(T(t.x, t.x, t.y));
      return o.add(i(o, o.yzx.add(200))), x(o.xx.add(o.yz).mul(o.zy));
    }, M = (t) => {
      const o = F(t), s = x(t), r = s.mul(s).mul(s.mul(-5).add(6)), e = g(o), a = g(o.add(n(1, 0))), l = g(o.add(n(0, 1))), p = g(o.add(n(1, 1)));
      return c(
        c(
          i(e.sub(3).mul(2), s),
          i(a.sub(3).mul(2), s.sub(n(1, 0))),
          r.x
        ),
        c(
          i(l.sub(3).mul(2), s.sub(n(0, 1))),
          i(p.sub(3).mul(2), s.sub(n(1, 1))),
          r.x
        ),
        r.y
      ).mul(0.1).add(3);
    }, D = () => {
      const o = S().sub(0.5), r = M(
        n(
          f.mul(0.02),
          o.x.mul(o.y)
        )
      ).sub(0.5).mul(400).add(90).mul(v.div(180)).add(f.mul(0.8)), e = n(
        o.x.mul(y(r)).sub(o.y.mul(u(r))),
        o.x.mul(u(r)).add(o.y.mul(y(r)))
      ), a = 12, l = b(200), p = f;
      return n(
        e.x.add(
          u(e.x.mul(a).add(p)).div(l)
        ),
        e.y.add(
          u(e.y.mul(a).mul(1.5).add(p)).div(l.mul(5e3))
        )
      );
    }, H = (t = n(0)) => {
      const o = k(
        -0.3,
        0.3,
        t.x.mul(y(v.div(360))).sub(t.x.mul(u(v.div(360))))
      ), s = k(
        0.3,
        -0.3,
        t.y
      ), r = c(
        d.color1.uniform,
        d.color2.uniform,
        o
      ), e = c(
        d.color3.uniform,
        d.color4.uniform,
        o
      );
      return c(r, e, s);
    }, z = (t) => {
      const o = n(b(0.5).add(E), V), s = U(S().sub(o)), r = b(R).add(u(f.mul(0.5)).mul(0.02).mul(t)), e = r.mul(b(A).mul(t)), a = r.sub(e), l = r.add(e);
      return k(
        l,
        a,
        s
      );
    }, I = D(), C = H(I), L = z(2), O = z(1), P = z(0.5), { correctedUV: q } = B(), h = j(0.3)(q), G = c(
      d.backgroundColor.uniform.sub(h.mul(0.7)),
      C.sub(h),
      L
    ), N = c(
      c(G, d.backgroundColor.uniform, 0.6),
      C.sub(h),
      O
    ), X = c(
      N,
      C.sub(h.mul(2)),
      P
    );
    return _(X, 1);
  }
};
export {
  W as componentDefinition,
  W as default
};
